import { useCallback } from "react";
import { useApi } from "../callApi/callApi";
import { FeedbackRequest, FeedbackResponse } from "../../features/cfbd/types/score";

/**
 * Custom hook for feedback operations
 */
export const useFeedback = () => {
  const callApi = useApi();

  const submitFeedback = useCallback(
    async (feedback: FeedbackRequest): Promise<FeedbackResponse | Error> => {
      try {
        const response = await callApi(
          "feedback",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(feedback),
          },
          "openid profile email"
        );
        if (!response.ok) throw new Error("Failed to submit feedback");
        const data: FeedbackResponse = await response.json();
        return data;
      } catch (err: any) {
        return err instanceof Error ? err : new Error("Unknown error");
      }
    },
    [callApi]
  );

  return {
    submitFeedback,
  };
};

export default useFeedback;
